module.exports = __webpack_public_path__ + "img/result.ba05ec03.png";